<div
  class="main-layout"
  inactivityListener
  inactivityMinutes="10"
  expMinutes="1"
  (onCloseSession)="logout()"
>
  <div
    #navbarRef
    class="main-layout__sidenav"
    [@openClose]="bp.isCompact() ? true : isExpanded"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    [ngClass]="{
      'min-h-full absolute z-20': bp.isCompact(),
      hidden: !isNavbarVisible(),
    }"
  >
    <div class="main-layout__sidenav__header">
      <div class="main-layout__sidenav__header__logo-container">
        <img
          class="cursor-pointer"
          src="assets/img/navbar/migo-iso.svg"
          alt="migo-iso"
        />
        <img
          *ngIf="isExpanded"
          src="assets/img/navbar/migo-logo.svg"
          alt="migo-iso"
        />
      </div>
      <img
        *ngIf="isExpanded"
        class="cursor-pointer"
        src="assets/img/navbar/arrow-left.svg"
        alt="migo-iso"
        (click)="isExpanded = false"
        (keypress.enter)="isExpanded = false"
        (keypress.space)="isExpanded = false"
      />
    </div>
    <div class="main-layout__sidenav__divider"></div>
    <div
      [ngClass]="{ expanded: isExpanded }"
      class="main-layout__sidenav__menus-container"
    >
      <div
        class="main-layout__sidenav__menus-container__menu"
        routerLink="/dashboard"
        routerLinkActive="active"
      >
        <mg-icons
          name="element_1"
          class="main-layout__sidenav__menus-container__menu__icon"
        ></mg-icons>
        <span
          *ngIf="isExpanded"
          class="main-layout__sidenav__menus-container__menu__text"
          >Dashboard</span
        >
        <mg-icons
          *ngIf="isExpanded"
          name="arrow_right"
          class="main-layout__sidenav__menus-container__menu__icon"
        ></mg-icons>
      </div>
      <ng-container *ngIf="checkView('transactions')">
        <div
          class="main-layout__sidenav__menus-container__menu"
          routerLink="/transactions"
          routerLinkActive="active"
        >
          <mg-icons
            name="arrow-swap-horizontal-navbar"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
          <span
            *ngIf="isExpanded"
            class="main-layout__sidenav__menus-container__menu__text"
            >Transacciones</span
          >
          <mg-icons
            *ngIf="isExpanded"
            name="arrow_right"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
        </div>
      </ng-container>

      <ng-container *ngIf="checkView('payoutCards')">
        <div
          class="main-layout__sidenav__menus-container__menu"
          routerLink="/payoutCards"
          routerLinkActive="active"
        >
          <mg-icons
            name="convertCard"
            class="main-layout__sidenav__menus-container__menu__icon text-mg-neutral-light"
          ></mg-icons>
          <span
            *ngIf="isExpanded"
            class="main-layout__sidenav__menus-container__menu__text"
            >Push Payments</span
          >
          <mg-icons
            *ngIf="isExpanded"
            name="arrow_right"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
        </div>
      </ng-container>

      <ng-container *ngIf="checkView('createTransaction')">
        <div
          class="main-layout__sidenav__menus-container__menu"
          routerLink="/createTransaction"
          routerLinkActive="active"
        >
          <mg-icons
            name="dollar-square"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
          <span
            *ngIf="isExpanded"
            class="main-layout__sidenav__menus-container__menu__text"
            >Link de pago</span
          >
          <mg-icons
            *ngIf="isExpanded"
            name="arrow_right"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
        </div>
      </ng-container>

      <ng-container *ngIf="checkView('users')">
        <div
          class="main-layout__sidenav__menus-container__menu"
          routerLink="/users"
          routerLinkActive="active"
        >
          <mg-icons
            name="user"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
          <span
            *ngIf="isExpanded"
            class="main-layout__sidenav__menus-container__menu__text"
            >Usuarios</span
          >
          <mg-icons
            *ngIf="isExpanded"
            name="arrow_right"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
        </div>
      </ng-container>
      <ng-container *ngIf="checkView('locks')">
        <div
          class="main-layout__sidenav__menus-container__menu"
          routerLink="/blocked-users"
          routerLinkActive="active"
        >
          <mg-icons
            name="user-remove-navbar"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
          <span
            *ngIf="isExpanded"
            class="main-layout__sidenav__menus-container__menu__text"
            >Usuarios bloqueados</span
          >
          <mg-icons
            *ngIf="isExpanded"
            name="arrow_right"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
        </div>
      </ng-container>
      <ng-container *ngIf="checkView('adminMetrics')">
        <div
          class="main-layout__sidenav__menus-container__menu"
          routerLink="/metrics/viewer"
          routerLinkActive="active"
        >
          <mg-icons
            name="graph-navbar"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
          <span
            *ngIf="isExpanded"
            class="main-layout__sidenav__menus-container__menu__text"
            >Métricas</span
          >
          <mg-icons
            *ngIf="isExpanded"
            name="arrow_right"
            class="main-layout__sidenav__menus-container__menu__icon"
          ></mg-icons>
        </div>
      </ng-container>
    </div>
    <div class="main-layout__sidenav__card-user">
      <ng-container *ngIf="user.avatarUrl; else textAvatarTemplate">
        <img
          [src]="user.avatarUrl"
          class="main-layout__sidenav__card-user__image"
          alt="avatar"
        />
      </ng-container>
      <ng-template #textAvatarTemplate>
        <div class="main-layout__sidenav__card-user__avatar">
          <span class="main-layout__sidenav__card-user__avatar__text">{{
            getInitials()
          }}</span>
        </div>
      </ng-template>
      <div
        *ngIf="isExpanded"
        class="main-layout__sidenav__card-user__user-info"
      >
        <span class="main-layout__sidenav__card-user__user-info__name">{{
          user.name
        }}</span>
        <span class="main-layout__sidenav__card-user__user-info__email">{{
          user.email
        }}</span>
      </div>
      <mg-icons
        *ngIf="isExpanded"
        name="more"
        class="main-layout__sidenav__card-user__icon"
        (click)="toggleContextMenu($event)"
        (keypress.enter)="toggleContextMenu($event)"
        (keypress.space)="toggleContextMenu($event)"
      >
        <migo-apps-context-menu
          *ngIf="contextMenuVisible"
          (logoutEmitter)="logout()"
          (closeMenu)="contextMenuVisible = false"
        >
        </migo-apps-context-menu>
      </mg-icons>
    </div>
  </div>

  <div
    class="main-layout__content"
    [ngClass]="{
      '!p-0': bp.isCompact(),
    }"
  >
    <nav
      *ngIf="!isErrorPage || bp.isCompact()"
      class="main-layout__toolbar"
      [ngClass]="{
        'w-full !p-4 !pb-0 gap-4': bp.isCompact(),
      }"
      aria-label="Barra de navegación principal"
    >
      <ng-container *ngIf="bp.isCompact() === false">
        <div class="flex items-center justify-start">
          <migo-apps-breadcrumb></migo-apps-breadcrumb>
        </div>
      </ng-container>

      <ng-container *ngIf="bp.isCompact()">
        <div
          #toggleButton
          class="compact-icon-container"
          (click)="toggleNavbar()"
          (keypress.enter)="toggleNavbar()"
          (keypress.space)="toggleNavbar()"
        >
          <img
            class="cursor-pointer"
            src="assets/img/navbar/migo-iso.svg"
            alt="migo-iso"
          />
          <mg-icons name="menu" class="w-6"> </mg-icons>
        </div>
      </ng-container>

      <div
        class="main-layout__toolbar__selected-client"
        (click)="openClientSearchDialog()"
        (keypress.enter)="openClientSearchDialog()"
        (keypress.space)="openClientSearchDialog()"
        [ngClass]="{ '!max-w-none': bp.isCompact() }"
        (mouseenter)="onMouseEnterScroll()"
        (mouseleave)="onMouseLeaveScroll()"
        (pointerdown)="onPressStart($event)"
        (pointerup)="onPressEnd($event)"
        (pointercancel)="onPressCancel()"
        (pointerleave)="onPressEnd($event)"
      >
        <img
          class="cursor-pointer"
          src="assets/img/navbar/migo-iso.svg"
          alt="migo-iso"
        />
        <div
          #nameContainer
          class="main-layout__toolbar__selected-client__name-container"
          [ngClass]="{ 'scroll-container': scrollText }"
        >
          <span
            #nameText
            class="main-layout__toolbar__selected-client__name-container__text"
            [ngClass]="{ 'scroll-text': scrollText }"
            >{{ (selectedClient$ | async)?.name || 'Ninguno' }}</span
          >
        </div>
        <div class="main-layout__toolbar__selected-client__icon-container">
          <mg-icons
            class="main-layout__toolbar__selected-client__icon-container__icon"
            name="repeat"
            [matTooltip]="'Cambiar cliente'"
            matTooltipPosition="above"
            matTooltipClass="custom-tooltip position-tooltip"
          ></mg-icons>
        </div>
      </div>
    </nav>

    <main
      class="main-layout__outlet"
      [ngClass]="{
        '!p-4':
          bp.isCompact() &&
          !(
            isErrorPage === true ||
            isAccountPage === true ||
            isPayoutPage === true
          ),
        '!rounded-none': bp.isCompact() && !(isErrorPage === true),
        '!p-0': isErrorPage === true || isAccountPage === true,
      }"
    >
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
